// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10px 10px 10px;
  background: white;
  margin: 0;
  overflow: hidden;
}

.title {
  font-family: AppFont, sans-serif;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0.06em;
  text-align: center;
  color: var(--color-black);
  text-transform: uppercase;
}

.info {
  font-family: AppFont, sans-serif;
  font-size: 12px;
  margin: 5px 0px 10px;
  letter-spacing: 0.02em;
  text-align: center;
  color: var(--color-black);
  text-transform: uppercase;
}

.button {
  height: 25px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  border-radius: 26px;
  text-transform: uppercase;
  font-family: AppFont !important;
  max-width: 150px;
  cursor: pointer;
}
.button:last-child {
  margin-bottom: 0;
}
.button:hover {
  background: #f2dbd9;
}
.button_main {
  background: var(--ion-color-primary);
  font-size: var(--buttons-font-size);
  font-size: 14px;
  line-height: 25px;
  letter-spacing: 0.06em;
  text-align: center;
  color: var(--color-white);
}
.button_close {
  background: transparent;
  font-size: 14px;
  min-height: 25px;
  text-align: center;
  border: 1px solid var(--ion-color-primary);
  margin: 0;
  text-transform: var(--buttons-text-transform);
  color: var(--ion-color-primary);
}`, "",{"version":3,"sources":["webpack://./src/app/components/change-venue-popover/change-venue-popover.component.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,SAAA;EAEA,gBAAA;AAAD;;AAGA;EACC,gCAAA;EACA,eAAA;EACA,iBAAA;EAEA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;AADD;;AAIA;EACC,gCAAA;EACA,eAAA;EACA,oBAAA;EAEA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;AAFD;;AAKA;EACC,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,+BAAA;EACA,gBAAA;EACA,eAAA;AAFD;AAGC;EACC,gBAAA;AADF;AAGC;EACC,mBAAA;AADF;AAGC;EACC,oCAAA;EACA,mCAAA;EAEA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;AAFF;AAKC;EACC,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,0CAAA;EAEA,SAAA;EACA,6CAAA;EACA,+BAAA;AAJF","sourcesContent":[".container {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding: 10px 10px 10px;\n\tbackground: white;\n\tmargin: 0;\n\n\toverflow: hidden;\n}\n\n.title {\n\tfont-family: AppFont, sans-serif;\n\tfont-size: 16px;\n\tfont-weight: bold;\n\n\tletter-spacing: 0.06em;\n\ttext-align: center;\n\tcolor: var(--color-black);\n\ttext-transform: uppercase;\n}\n\n.info {\n\tfont-family: AppFont, sans-serif;\n\tfont-size: 12px;\n\tmargin: 5px 0px 10px;\n\n\tletter-spacing: 0.02em;\n\ttext-align: center;\n\tcolor: var(--color-black);\n\ttext-transform: uppercase;\n}\n\n.button {\n\theight: 25px;\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tmargin-bottom: 10px;\n\tborder-radius: 26px;\n\ttext-transform: uppercase;\n\tfont-family: AppFont !important;\n\tmax-width: 150px;\n\tcursor: pointer;\n\t&:last-child {\n\t\tmargin-bottom: 0;\n\t}\n\t&:hover {\n\t\tbackground: #f2dbd9;\n\t}\n\t&_main {\n\t\tbackground: var(--ion-color-primary);\n\t\tfont-size: var(--buttons-font-size);\n\n\t\tfont-size: 14px;\n\t\tline-height: 25px;\n\t\tletter-spacing: 0.06em;\n\t\ttext-align: center;\n\t\tcolor: var(--color-white);\n\t}\n\n\t&_close {\n\t\tbackground: transparent;\n\t\tfont-size: 14px;\n\t\tmin-height: 25px;\n\t\ttext-align: center;\n\t\tborder: 1px solid var(--ion-color-primary);\n\n\t\tmargin: 0;\n\t\ttext-transform: var(--buttons-text-transform);\n\t\tcolor: var(--ion-color-primary);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
